<template>
  <div>
    <el-drawer
        size="80%"
        custom-class="custom-drawer"
        title="推广商品列表"
        :visible.sync="visible">
      <div style="padding: 20px">
        <div class="forms-container">
          <el-form :model="searchForm" class="search-form" ref="searchFormRef">
            <el-form-item label="" prop="searchContent">
              <el-input
                  style="width:300px"
                  :maxlength="100"
                  v-model="searchForm.searchContent"
                  placeholder="券商品名称/ID"
              />
            </el-form-item>
            <el-form-item>
              <!-- 操作按钮 -->
              <el-button type="warning" @click="onFormSearch">查询</el-button>
              <el-button type="warning" plain @click="onFormReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="tableList.list" v-loading="loading" highlight-current-row border style="width: 100%">
          <el-table-column prop="name" label="券商品名称"/>
          <el-table-column prop="templateCode" label="券商品ID" />
          <el-table-column prop="darenNum" label="推广达人数" >
            <template #header>
              <div style="display: flex;gap: 6px;align-items: baseline;">
                当前推广达人数
                <el-tooltip effect="dark" placement="top" content="统计这个商品关联该团长的当前在推广的达人数">
                  <el-icon class="el-icon-question" />
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              {{scope.row.darenNum }}
            </template>
          </el-table-column>
          <el-table-column prop="commissionRate" label="商品总佣比例" >
            <template #header>
              <div style="display: flex;gap: 6px;align-items: baseline;">
                商品总佣比例（%）
                <el-tooltip effect="dark" placement="top" content="取给团长设置的商品总佣金设置">
                  <el-icon class="el-icon-question" />
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              {{scope.row.commissionRate }}
            </template>
          </el-table-column>
          <el-table-column prop="agentCommissionBd" label="券总佣金" >
            <template #header>
              <div style="display: flex;gap: 6px;align-items: baseline;">
                商品总佣金
                <el-tooltip effect="dark" placement="top" content="指这个商品累计所有产生的总佣金（商品售价*总佣金比例）之和">
                  <el-icon class="el-icon-question" />
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              {{scope.row.agentCommissionBd }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            v-if="tableList.total > 0"
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableList.currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="tableList.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableList.total"
        >
        </el-pagination>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
import poi from "@/api/poi";
const PoiModel = new poi();
export default {
  data() {
    return {
      searchForm: {
        searchContent: '',
      },
      openParams:{},
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      loading: false,
      tableList:{
        pageSize: 10,
        currentPage: 1,
        total: 0,
        list:[],
      },
      visible: false
    }
  },
  methods:{
    open(params){
      this.openParams = params;
      this.visible = true;
      this.getList()
    },
    getParams(){
      return {
        ...this.openParams,
        ...this.searchForm,
      }
    },
    async getList() {
      this.loading = true
      const res = await PoiModel.getDistributeGoodsNum({
        ...this.getParams(),
        pageNo: this.params.pageNo,
        pageSize: this.params.pageSize,
      });
      if(!res.data.success) {
        this.$message.error(res.data.message);
        return;
      }
      this.tableList.list = res.data.data.list || [];
      this.tableList.total = res.data.data.total || 0;
      this.loading = false;
      this.tableList.currentPage = res.data.data.pageNo;
      this.tableList.pageSize = res.data.data.pageSize;
    },
    // 表单搜素
    onFormSearch() {
      debounce(
          () => {
            this.$refs['searchFormRef'].validate((valid) => {
              if (valid) {
                this.params.pageNo = 1;
                this.getList();
              } else {
                return false;
              }
            });
          },
          500,
          true
      );
    },
    reset() {
      this.searchForm = {
        searchContent: '',
      }
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.$refs['searchFormRef'].resetFields();
    },
    onFormReset() {
      debounce(() => {
        this.reset()
        this.getList()
      }, 1000, true)
    },
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getList();
    },
  },
};
</script>

<style>
.pagination {
  margin-top: 20px;
  text-align: right;
}
.custom-drawer{
  overflow-y: scroll !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/popDistributeGoodsNum.vue